export const states = {
  enter: 'enter',
  entering: 'entering',
  entered: 'entered',
  exit: 'exit',
  exiting: 'exiting',
  exited: 'exited',
};

export const stateClassNames = {
  enter: ['enter'],
  entering: ['enter', 'enterActive'],
  entered: ['enterDone'],
  exit: ['exit'],
  exiting: ['exit', 'exitActive'],
  exited: ['exitDone'],
};
